import $ from 'jquery'
import { popupController } from './popupController';
export const icitGMap = function(selector, passedMarkers) {

  let geocoder = null;
  const mapSelector = selector;
  let map = null;
  let markers;
  const gmapMarkers = [];
  // let geocodeCounter = 0;
  let drawingManager = null;

  const init = function(selector, passedMarkers) {
    map = new google.maps.Map(document.getElementById(selector), {
      zoom: 8,
      center: {lat: 0, lng: 0},
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      maxZoom: 12
    });
    markers = passedMarkers;
    addCurrentLocationButton();
    
    /**
     * Use location variable
     */
    addMarkersWithLocation();
    setCenter();
    enableClusters();
    enableDrawing();
  }

  const addMarkersWithLocation  = function() {

    for (let markerIndex = 0; markerIndex < markers.length; markerIndex++)
    {
      try {
        addMarker(markers[markerIndex]);
      } catch (e) {}
    }

  }

  const addMarker = function(passedMarker) {
    const marker = new google.maps.Marker({
      map,
      position: passedMarker.location
    });
    gmapMarkers.push(marker);
  }

  const setCenter = function() {
    const bounds = new google.maps.LatLngBounds();
    for (let i = 0; i < markers.length; i++) 
    {
      bounds.extend(markers[i].location);
    }
    map.fitBounds(bounds);
  }

  const enableClusters = function() {
    if ( 'function' !== typeof MarkerClusterer )
    {
      $.getScript('https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js', enableClusters);
      return;
    }

    new MarkerClusterer(map, gmapMarkers, {
      imagePath:
        "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
    });
  }

  const addCurrentLocationButton = function() {
    var infoWindow = new google.maps.InfoWindow();

    const locationButton = document.createElement('button');
    locationButton.textContent = '';
    locationButton.classList.add('gmap-custom-location-button');
    locationButton.setAttribute('aria-label', 'My location');
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(locationButton);

    locationButton.addEventListener("click", () => {
      // Try HTML5 geolocation.
      if ( !navigator.geolocation ) {
        alert('Your browser doesn\'t support geolocation.');
      }

      navigator.geolocation.getCurrentPosition(function(position){
        const pos = { lat: position.coords.latitude, lng: position.coords.longitude };
        infoWindow.setPosition(pos);
        infoWindow.setContent("You are here");

        infoWindow.open(map);
        map.setCenter(pos);

      }, function() {
        alert('The Geolocation service failed.'); // on error
      });
    });

  }

  const enableDrawing = function() {

    drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          // google.maps.drawing.OverlayType.MARKER,
          // google.maps.drawing.OverlayType.CIRCLE,
          // google.maps.drawing.OverlayType.POLYGON,
          // google.maps.drawing.OverlayType.POLYLINE,
          google.maps.drawing.OverlayType.RECTANGLE,
        ],
      },
      rectangleOptions: {
        fillColor: '#ebe8e5',
        fillOpacity: 0.5,
        strokeColor: '#5C8727',
        strokeWeight: 2,
        clickable: false,
        editable: false,
        zIndex: 1,
      },
    });

    drawingManager.setMap(map);

    let selectedShape = null;
    google.maps.event.addListener(drawingManager, 'overlaycomplete', function(event){                                       
      selectedShape = event.overlay;
      drawingManager.setDrawingMode(null); // Return to 'hand' mode 

      const bounds = selectedShape.getBounds();
      userRectangleSelected(bounds);
    });  

    const clearSelection = function(e) {
      if (null === selectedShape) {return;}
      if (
        (drawingManager.getDrawingMode() == google.maps.drawing.OverlayType.RECTANGLE) 
        && 
        (selectedShape != null)
      )
      {
        selectedShape.setMap(null);
      }
    };
    google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);

    $('body').on('click', '.btn-map-select-area', function(e) {
      e.preventDefault();
      drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
    })
    

  }

  const userRectangleSelected = function(bounds) {
    const coords = [];
    const start = bounds.getNorthEast();
    const end = bounds.getSouthWest();


    coords.push(start.lat());
    coords.push(start.lng());
    coords.push(end.lat());
    coords.push(end.lng());

    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.append('user_area', coords);

    const html = `<h3>Do you want to search careers in selected area?</h3>
    <div style="display: flex;justify-content: center;gap: 15px;">
      <a href="#" class="btn btn-filled" style="padding: 5px 30px;" onclick="window.location.href = '${currentUrl.href}'">Yes</a>
      <a href="#" class="btn btn-cta close-btn" style="padding: 5px 30px;position: unset;line-height: 23px;">No</a>
    </div>`
    const popup = new popupController(html);
    popup.getObject().find('.popup-inner').css({
      'background' : '#fff',
      'padding' : '15px',
      'padding-top' : '40px'
    });
    popup.show();
  }

  init(mapSelector, passedMarkers);
}